// Detecção de plataforma sem import estático do Capacitor: o bundle web
// (nginx) não carrega nenhum pacote @capacitor/* e continua funcionando
// exatamente como hoje. Só quando o app roda dentro do WebView nativo é que
// window.Capacitor existe, injetado pelo runtime do Capacitor.
export const isNative = () => Boolean(globalThis.Capacitor?.isNativePlatform?.());
export const getPlatform = () => globalThis.Capacitor?.getPlatform?.() ?? 'web';
export const isIOS = () => getPlatform() === 'ios';
export const isAndroid = () => getPlatform() === 'android';
